import React, { createContext, ReactNode } from 'react'
import { useShareApi } from 'apps/fleet-planner/hooks'
import * as Types from 'apps/fleet-planner/types'

type ShareLoadContextState = ReturnType<typeof useShareApi>

/**
 * Init the context
 */
export const shareLoadDefaultState: ShareLoadContextState = {
  shipmentShares: [] as Types.IShare[],
  isLoading: false,
} as ShareLoadContextState

// Creates the context object that we'll pass into components
export const ShareLoadContext = createContext<ShareLoadContextState>(shareLoadDefaultState)

interface IShareLoadProviderProps {
  children: ReactNode
}

/**
 * Provide default Provider state component to wrap around app
 */
export const ShareLoadProvider: React.FC<IShareLoadProviderProps> = ({ children }): JSX.Element => {
  const shareLoadState = useShareApi()
  return <ShareLoadContext.Provider value={shareLoadState}>{children}</ShareLoadContext.Provider>
}
